import Lockr from 'lockr';
import { STORAGE_KEY, IDENTITY_KEY_NAME } from '@/constants';

export const getPageByStorage = name => Lockr.get(STORAGE_KEY.PAGES, {})[name];

const getValueByStorageKey = {
  [IDENTITY_KEY_NAME.TOKEN]: () => Lockr.get(STORAGE_KEY.TOKEN, undefined),
  [IDENTITY_KEY_NAME.UID]: () => Lockr.get(STORAGE_KEY.STUDENT_ID),
  [IDENTITY_KEY_NAME.APP_VERSION]: () => Lockr.get(STORAGE_KEY.APP_VERSION),
  [IDENTITY_KEY_NAME.APP_NAME]: () => Lockr.get(STORAGE_KEY.APP_NAME),
  [IDENTITY_KEY_NAME.DEVICE_TYPE]: () => Lockr.get(STORAGE_KEY.DEVICE_TYPE),
};

export default getValueByStorageKey;
